import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
    name: "forms",
    initialState: {
        list: [],
        loading: false,
        lastFetch: null,
        addedStatus:false,
        sendStatus:false,
        sendLoading:false,
        deleteStatus:false,
        deleteLoading:false,
        editAllowStatus:false,
        formById:null,
    },
    reducers: {
        formLibraryRequestStarted: (forms) => {
            forms.loading = true;
            forms.addedStatus = false;
            forms.sendStatus = false;
            forms.deleteStatus = false;
            forms.editAllowStatus = false;
        },
        formLibraryRequestFailed: (forms) => {
            forms.loading = false;
        },
        formLibraryReceived:(forms,action)=>{
            forms.list=action.payload;
            forms.addedStatus=false;
            forms.sendStatus=false;
            forms.deleteStatus=false;
            forms.editAllowStatus=false;
            forms.loading = false;
        },
        formLibraryAdded:(forms,action)=>{
            forms.addedStatus=true;
        },
        formLibrarySendStarted:(forms)=>{
            forms.sendLoading=true;
        },
        formLibrarySent:(forms,action)=>{
            forms.sendStatus=true;
            forms.sendLoading=false;
        },
        formLibraryDeleteStarted:(forms)=>{
            forms.deleteLoading=true;
        },
        formLibraryDeleted:(forms,action)=>{
            forms.deleteStatus=true;
            forms.deleteLoading=false;
        },
        libraryFormByIdReceived:(forms,action)=>{
            forms.formById=action.payload;
        },
        formLibraryEditAllowed:(forms,action)=>{
            forms.editAllowStatus=action.payload;
        },
        
    }
});

export const { formLibraryReceived, formLibraryAdded,
    formLibrarySendStarted, formLibrarySent, formLibraryDeleteStarted, formLibraryDeleted,
    libraryFormByIdReceived,
    formLibraryEditAllowed, formLibraryRequestStarted, formLibraryRequestFailed } = slice.actions;

export default slice.reducer;

export const loadAppLibraryForms = (id) => apiCallBegan({
    url: config.GetFormsLibrary + id,
    onStart: { type: formLibraryRequestStarted.type },
    onError: { type: formLibraryRequestFailed.type },
    onSuccess: formLibraryReceived.type
});

export const loadLibraryFormById= (id) => apiCallBegan({
    url: config.GetFormLibraryById + id,
    onSuccess: libraryFormByIdReceived.type
});

export const addFormLibrary = (data) => apiCallBegan({
    url: config.AddFormLibrary,
    method:"post",
    data:data,
    onSuccess: formLibraryAdded.type
});

export const sendFormLibraryToApplicant = (id) => apiCallBegan({
    url: config.SendLibraryForm+id,
    onStart: { type: formLibrarySendStarted.type },
    onSuccess: formLibrarySent.type
});

export const deleteFormLibrary = (id) => apiCallBegan({
    url: config.DeleteFormLibrary+id,
    onStart: { type: formLibraryDeleteStarted.type },
    onSuccess: formLibraryDeleted.type
});

export const allowFormLibraryEdit = (id,allow,notes) => apiCallBegan({
    url: config.EditAllowFormLibrary + id + "&allow=" + allow+"&notes="+notes,
    onSuccess: formLibraryEditAllowed.type
});

export const getAppFormLibrary = createSelector(
    state => state.entities.forms,
    forms => forms.list
);

export const getAppFormLibraryLoading = createSelector(
    state => state.entities.forms,
    forms => forms.loading
);

export const getAppFormLibrarySendStatus = createSelector(
    state => state.entities.forms,
    forms => forms.sendStatus
);

export const getAppFormLibraryDeleteStatus = createSelector(
    state => state.entities.forms,
    forms => forms.deleteStatus
);

export const getFormLibraryEditStatus = createSelector(
    state => state.entities.forms,
    forms => forms.editAllowStatus
);

export const getLibraryFormById = createSelector(
    state => state.entities.forms,
    forms => forms.formById
);

export const getLibraryFormAddedStatus = createSelector(
    state => state.entities.forms,
    forms => forms.addedStatus
);

export const getAppFormLibrarySendLoading = createSelector(
    state => state.entities.forms,
    forms => forms.sendLoading
);

export const getAppFormLibraryDeleteLoading = createSelector(
    state => state.entities.forms,
    forms => forms.deleteLoading
);

